import home from "@project/templates/home/home";
import agileIT from "@project/templates/agile-it/agile-it";
import skills from "@project/templates/skills/skills";
import trombinoscope from "@project/templates/trombinoscope/trombinoscope";
import contact from "@project/templates/contact/contact";
import onePage from "@project/templates/one-page/one-page";
import documentation from "./documentation/documentation";
import articles from "@project/templates/articles/projectArticle";
import blog from "./blog/blog";
export default [
    home,
    agileIT,
    onePage,
    skills,
    trombinoscope,
    contact,
    documentation,
    articles,
    blog,
];
